import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { EmployeeInsuranceRegion, EmployeeInsuranceSIStatus } from "./types";

export const EmployeeInsuranceSIStatusOptions = [
  {
    label: i18n.t("kept"),
    value: EmployeeInsuranceSIStatus.Kept,
  },
  {
    label: i18n.t("lost"),
    value: EmployeeInsuranceSIStatus.Lost,
  },
  {
    label: i18n.t("none"),
    value: EmployeeInsuranceSIStatus.None,
  },
];

export const EmployeeInsuranceSIStatusMap = getMapObjectFromArray(
  EmployeeInsuranceSIStatusOptions
);

export const EmployeeInsuranceRegionOptions = [
  {
    label: "K1",
    value: EmployeeInsuranceRegion.R1,
  },
  {
    label: "K2",
    value: EmployeeInsuranceRegion.R2,
  },
  {
    label: "K3",
    value: EmployeeInsuranceRegion.R3,
  },
];
